import { Component, Inject, inject, InjectionToken, Injector, Input, signal, TemplateRef, viewChild } from '@angular/core';
import { AuthorizationsApiClientService } from '../../../../../../../core/src/lib/api/v1/api/authorizationsApi.client.service';
import {
  NIASBizBllModelsAuthDocumentPreviewInfo,
  NIASBizBllModelsAuthDocumentQuery,
} from '../../../../../../../core/src/lib/api/v1';
import { SortByEnum } from '../../../../../../../core/src/lib/enums/sort-by.enum';
import { SortByDirectionEnum } from '../../../../../../../core/src/lib/enums/sort-by-direction.enum';
import {
  ITableColumn,
  ColumnType,
  ITablePagination,
} from '../../../../../../../core/src/lib/components/table/table.types';
import { TableComponent } from '../../../../../../../core/src/lib/components/table/table.component';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { IAuthorisationFilterModelForm } from './authorisations-filter-form.model';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { ExpandableTableComponent } from '../../../../../../../core/src/lib/components/expandable-table/expandable-table.component';
import { ExpandedAuthorisationComponent } from '../../expanded-authorisation/expanded-authorisation/expanded-authorisation.component';
import { CommonModule } from '@angular/common';
import { SupervisorAuthService } from '../../../../../../../core/src/lib/services/supervisor-auth.service';

@Component({
  selector: 'app-authorisations-page-supervisor',
  imports: [
    ExpandableTableComponent,
    NzButtonModule,
    FormsModule,
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    CommonModule,
  ],
  templateUrl: './authorisations-page-supervisor.component.html',
  styleUrl: './authorisations-page-supervisor.component.scss',
})
export class AuthorisationsPageSupervisor {
  private authorisationsApiClientService = inject(AuthorizationsApiClientService);
  ListOfModels?: NIASBizBllModelsAuthDocumentPreviewInfo[] = [];
  private fb = inject(FormBuilder);
    public supervisorAuthService: SupervisorAuthService = inject(SupervisorAuthService);
  
  public expandedRows: Set<any> = new Set();

  constructor(private injector: Injector) {}

  public tablePagination = signal<ITablePagination>({ pageSize: 10, pageIndex: 1, total: 0 });

  
  DynamicComponent: any;
  selectedRowData: any;

  authDocQuery: NIASBizBllModelsAuthDocumentQuery = {
    Skip: this.getSkipValue(),
    Take: this.tablePagination().pageSize,
    PersonSearch: '',
    SortBy: SortByEnum.LastIdAuthDocumentSignature,
    SortByDirection: SortByDirectionEnum.DESC,
    LegalSearch: '',
    ForPersonSearch: '',
    ServiceSearch: '',
    SearchFromLegal: '',
    AuthListType: NIASBizBllModelsAuthDocumentQuery.AuthListTypeEnum.NUMBER_4,
    SearchQuery: '',
    SearchDocumentStateIds: [7], //mora bit 7 to jedino supervisor smije
  };

  public form = this.fb.group<IAuthorisationFilterModelForm>({
    BusinessSubject: this.fb.control(null),
    Service: this.fb.control(null),
  });

  public getSkipValue(): number {
    const PageIndex = this.tablePagination().pageIndex;
    return (PageIndex - 1) * this.tablePagination().pageSize;
  }

 

  public tableColumns = () => [

     {
        header: {
          key: '__i',
          label: '#',
          type: ColumnType.TEXT,
        },
        cellValue: (row: any) => row.__i || '',
      },
      {
        header: {
          key: 'LegalEntity',
          label: 'Poslovni subjekt',
          type: ColumnType.TEXT,
        },
        cellValue: (data: NIASBizBllModelsAuthDocumentPreviewInfo) => data.LegalEntity || '',
      },
      {
        header: {
          key: 'Service',
          label: 'Ovlaštenje',
          type: ColumnType.TEXT,
        },
        cellValue: (data: NIASBizBllModelsAuthDocumentPreviewInfo) => data.Service || '',
      },
      {
        header: {
          key: '__i',
          label: 'Akcije',
          type: ColumnType.TEMPLATE,
        },
        cellValue: (row: any) => '',
      },
  ];

 actionButtonTemplate() {
    return '2';
  }
  public onFormSubmit() {
    const data = this.form.getRawValue();

    if (data.BusinessSubject != null) {
      this.authDocQuery.LegalSearch = data.BusinessSubject;
    }

    if (data.Service != null) {
      this.authDocQuery.ServiceSearch = data.Service;
    }
    this.RefreshData();
  }

  ngOnInit() {
    
    var userData = sessionStorage.getItem("supervisorUser");

    if(userData){
        this.supervisorAuthService.saveUser(JSON.parse(userData))
    }
  }

  clearForm() {
    this.authDocQuery.ServiceSearch = '';
    this.authDocQuery.LegalSearch = '';
    this.form.setValue({
      BusinessSubject: '',
      Service: '',
    });

    this.RefreshData();
  }

  public RefreshData() {
    const currentSkip = this.authDocQuery.Skip;
    this.authorisationsApiClientService.authorizationsApiGetAuthorizeList(this.authDocQuery).subscribe((x) => {
      this.ListOfModels = [];
      this.ListOfModels = x.ItemList?.map((item, i) => ({
        ...item,
        __i: currentSkip! + i + 1,
      }));
      this.tablePagination().total = x.TotalCount!;
    });
  }

  tableData(): NIASBizBllModelsAuthDocumentPreviewInfo[] {
    return this.ListOfModels || [];
  }

  onRowClick(row: any) {
    this.DynamicComponent = ExpandedAuthorisationComponent;
  }

  public onQueryParamsTable(query: NzTableQueryParams) {
    this.authDocQuery.Skip = (query.pageIndex - 1) * query.pageSize;
    this.authDocQuery.Take = query.pageSize;
    this.RefreshData();
  }
}
